import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { format as phoneFormat } from 'libphonenumber-js';

import './PropertyInfo.css';

const PropertyInfo = observer(
class PropertyInfo extends Component {
  render() {
    const {
      twilioNumber = "",
      doorOpenNumber = "*",
    } = this.props.property || {};

    const phoneNumber = (twilioNumber) ? phoneFormat(twilioNumber, "US", "National") : "Loading...";
    return (
      <section>
        <p>
          Give this number, <code className="PropertyInfo-phoneNumber">{phoneNumber}</code>{", "}
          to your building manager to set as your intercom number.{" "}
        </p>
        <p>
          <b className="PropertyInfo-passcode-io">Passcode.io</b> will press {" "}
          <code className="PropertyInfo-doorOpenNumber">{doorOpenNumber}</code>{" "}
          to grant your guests access to your front door if they enter the {" "}
          one of the enabled passcodes below.
        </p>
      </section>
    );
  }
});

export default PropertyInfo;


// WEBPACK FOOTER //
// ./src/components/Property/PropertyInfo.js